import { createContext } from 'react';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';

export interface IApplicationQueryContextValue {
	executionOptions?: IExecutionOptions;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ApplicationQueryContext = createContext<IApplicationQueryContextValue>({});
